import { useCallback } from "react";
import adminApi from "../api/adminApi";
import useClientContext from "../context/useClientContext";

const useGetObjectPageLayout = (objectType: string) => {
  const { isFundAdmin } = useClientContext();

  return useCallback(
    () => (isFundAdmin ? adminApi.getObjectConfigurationLayout(objectType) : adminApi.getCardLayout(objectType)),
    [isFundAdmin, objectType]
  );
};

export default useGetObjectPageLayout;
